import React from "react";
import classNames from "../../utils/classNames";

// Underline tabs for switching views within a page (not routes; see
// ./index.jsx for route tabs). A rule runs the full width under the tabs and
// the active tab is marked with a brand-colored underline sitting on it.
//
//   tabs:      [{ name: string }]
//   activeTab: the active tab's name
//   onChange:  (name) => void
//   actions:   optional node shown at the right end of the row (e.g. a button)
function UnderlineTabs({ tabs = [], activeTab, onChange, actions }) {
  return (
    <div className="flex items-end justify-between gap-4 border-b border-gray-200 dark:border-gray-700">
      <nav className="-mb-px flex gap-x-6 overflow-x-auto" aria-label="Tabs">
        {tabs.map((tab) => {
          const active = tab.name === activeTab;
          return (
            <button
              key={tab.name}
              type="button"
              onClick={() => onChange(tab.name)}
              className={classNames(
                active
                  ? "border-brand-primary text-gray-900 dark:text-gray-100 font-semibold"
                  : "border-white/0 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 font-medium",
                "whitespace-nowrap border-b-2 px-1 py-3 text-sm transition-colors duration-200"
              )}
              aria-current={active ? "page" : undefined}
            >
              {tab.name}
            </button>
          );
        })}
      </nav>
      {actions && <div className="shrink-0 pb-2">{actions}</div>}
    </div>
  );
}

export { UnderlineTabs };
